import { ReactNode } from 'react';

import { StyledFlex } from '@dreryk/react-components';

import { FormSection } from './components/section/FormSection';

type FormProps = {
   readonly children: ReactNode;
};

export const Form = (props: FormProps): JSX.Element => {
   return (
      <form noValidate>
         <StyledFlex direction={'column'} gap={'40px'}>
            {props.children}
         </StyledFlex>
      </form>
   );
};

Form.Section = FormSection;
